module.exports = __webpack_public_path__ + "static/media/logo-2020-white.219d4189.svg";